import Box from "@mui/material/Box";
import NavBar from "components/NavBar";
import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import useComponentLogic from "./useComponentLogic";
import ConversationsList from "components/ConversationsList";
import Chat from "components/Chat";
import Typography from "@mui/material/Typography";
import { defaultColorPallete, redirectToAlyviaSSO } from "utils";
import ConversationsFilter from "components/ConversationsFilter";
import ForumTwoToneIcon from "@mui/icons-material/ForumTwoTone";
import IconButton from "@mui/material/IconButton";
import { useEffect } from "react";
import { useMixpanel } from "utils/hooks/useMixPanel";
import { useSelectedDeviceStore } from "store/useSelectedDeviceStore";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import { useConversationSummaryStore } from "store/useConversationSummaryStore";
import { useShallow } from "zustand/shallow";
import ConversationSummary from "components/Chat/ConversationSummary";

export default function MainPage() {
  const {
    selectedConversation,
    conversationsLoading,
    selecteConversation,
    searchTerm,
    setSearchTerm,
    fetchNextPage,
    fetchPreviousPage,
    hasNextPage,
    hasPreviousPage,
    isFetchingNextPage,
    isFetchingPreviousPage,
  } = useComponentLogic();

  const { pageView, chatInteraction } = useMixpanel();
  const { selectedDevice } = useSelectedDeviceStore();

  useEffect(() => {
    if (window.location.pathname === "/main") {
      pageView("/chat", selectedDevice);
    }
  }, [selectedDevice]);

  const {
    closeConversationSummary,
    conversationsSummary
  } = useConversationSummaryStore(
    useShallow((state) => ({
      closeConversationSummary: state.closeConversationSummary,
      conversationsSummary: state.conversationsSummary,
    })),
  );
const conversationSummary = conversationsSummary && conversationsSummary[selectedConversation.id]

  return (
    <>
      <NavBar />
      <Box display="flex" overflow={"hidden"} height={"100%"}>
        <Box
          width={{ xs: "100%", md: "30%" }}
          height="100%"
          display={{ md: "flex", xs: !selectedConversation ? "flex" : "none" }}
          flexDirection={"column"}
          alignItems={{ xs: "center", xl: "flex-end" }}
          sx={{
            transition: 'width 1s cubic-bezier(0.4, 0, 0.2, 1)',
            bgcolor: '#EFF1F2'
          }}
        >
          <Box
            bgcolor={"white"}
            boxShadow={1}
            width={"100%"}
            height={"70px"}
            display={"flex"}
            justifyContent={{ xs: "center", xl: "end" }}
          >
            <Box
              width={{ xs: "90%", xl: "80%" }}
              display={"flex"}
              justifyContent="space-between"
              height={"100%"}
              alignItems={"center"}
              pr={2}
            >
              {/* <MessageOutlinedIcon fontSize='medium' /> */}
              <IconButton
                title="Ir para o Alyvia SSO"
                onClick={redirectToAlyviaSSO}
              >
                <HomeIcon fontSize="medium" />
              </IconButton>
              {/* <ArchiveIcon fontSize='medium' /> */}
              {/* <SettingsIcon fontSize='medium' /> */}
            </Box>
          </Box>
          <Box
            width={{ xs: "90%", xl: "80%" }}
            display={"flex"}
            flexDirection={"column"}
            height="90%"
            flexGrow={1}
          >
            <Box mt={2} pr={2}>
              <FormControl fullWidth>
                <TextField
                  size="small"
                  placeholder="Buscar por nome ou número..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </FormControl>
            </Box>
            <ConversationsFilter />
            <ConversationsList
              key={searchTerm}
              searchTerm={searchTerm}
              conversationsLoading={conversationsLoading}
              onClickConversation={(conversation) => {
                const deviceId =
                  selectedDevice ?? conversation.deviceId ?? "desconhecido";
                chatInteraction(deviceId, "thread");
                selecteConversation(conversation);
              }}
              hasNextPage={hasNextPage}
              hasPreviousPage={hasPreviousPage}
              isFetchingNextPage={isFetchingNextPage}
              isFetchingPreviousPage={isFetchingPreviousPage}
              fetchNextPage={fetchNextPage}
              fetchPreviousPage={fetchPreviousPage}
            />
          </Box>
        </Box>
        <Box
          flex={1}
          bgcolor="white"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          key={`chatSection-${selectedConversation?.id}`}
          display={{
            lg: 'flex',
            md: !conversationSummary ? 'flex' : 'none',
            xs: selectedConversation && !conversationSummary ? 'flex' : 'none',
          }}
        >
          {!selectedConversation && <NoConversationsInfo />}
          {selectedConversation && <Chat />}
        </Box>

        {conversationSummary &&(
          <ConversationSummary
            conversationSummary={conversationSummary}
            closeConversationSummary={() => closeConversationSummary(selectedConversation.id)}
          />
        )}
      </Box>
    </>
  );
}

function NoConversationsInfo() {
  return (
    <Box width="100%" justifyItems="center">
      <Box
        mb={4}
        bgcolor={defaultColorPallete.pastelBlue.light}
        borderRadius="100%"
        height={192}
        width={192}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <ForumTwoToneIcon sx={{ color: "white", fontSize: 100 }} />
      </Box>
      <Typography
        fontWeight="bold"
        fontSize="3rem"
        color={defaultColorPallete.primary.main}
      >
        Boas vindas à Alyvia Chat!
      </Typography>
      <Typography>
        A partir de agora, suas conversas serão exibidas aqui
      </Typography>
    </Box>
  );
}
